import { render, staticRenderFns } from "./html5.vue?vue&type=template&id=ef743e90"
import script from "./html5.vue?vue&type=script&lang=js"
export * from "./html5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports